export default __webpack_public_path__ + "static/media/Img0010_fin.6dcc2e9d.jpg";